<template>
    <div id="content" v-if="!loading">
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>
            <h1>{{ entity.name }}</h1>
        </div>
        <div class="responsiveTabs">
            <ul class="tabs">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'vodProvidersSettings'}"><a
                    @click.stop="openRoute('vodProvidersSettings')" v-translate>Vlastnosti</a></li>
              <li :class="{'r-tabs-state-active' : this.$route.name === 'vodProvidersPackages'}"><a
                  @click.stop="openRoute('vodProvidersPackages')" v-translate>Balíčky videí</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'vodProvidersVideos'}"><a
                    @click.stop="openRoute('vodProvidersVideos')" v-translate>Videa</a></li>
            </ul>

            <keep-alive>
                <router-view
                    :entity="entity"
                />
            </keep-alive>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
            </p>
          </section>
        </div>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"

export default {
    name: "VodProvidersDetail",
    mixins: [
        detailActions,
    ],
    data() {
        return {
            entityName: "vodProvider",
            moduleName: "vodProviders",
            loading: true,
        }
    },
    created(VodProviderService) {
        this.entityService = VodProviderService
        this.createdInit()
    },
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodProviders/VodProvidersDetail.vue